import { render } from "./HolderAbout.vue?vue&type=template&id=044223a6&scoped=true"
import script from "./HolderAbout.vue?vue&type=script&lang=js"
export * from "./HolderAbout.vue?vue&type=script&lang=js"

import "./HolderAbout.vue?vue&type=style&index=0&id=044223a6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-044223a6"]])

export default __exports__